import React from 'react';
import { rotate360 } from '../../keyframes';
import styled from '../../styled';
const LoadingSpinner = styled.div `
  background: conic-gradient(
    from 180deg at 50% 50%,
    ${({ color = 'INK_500', theme }) => theme.colors[color]} 0deg,
    transparent 360deg
  );
  border-radius: 50%;
  width: ${({ size }) => size || '2'}rem;
  height: ${({ size }) => size || '2'}rem;
  position: relative;
  animation: ${rotate360} 1s linear infinite;

  ::before {
    position: absolute;
    content: '';
    background: ${({ theme }) => theme.colors.SNOW_LIGHT};
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 70%;
    height: 70%;
    border-radius: 50%;
  }
`;
const PartialLoadingSpinner = ({ color, size }) => (React.createElement(LoadingSpinner, { color: color, size: size }));
export default PartialLoadingSpinner;
//# sourceMappingURL=PartialSpinner.js.map